import React from 'react';
import { Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row, InputGroup } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Dropzone from './Dropzone';
import Loader from '../Loader/Loader';
import CurrencyConverter from '../CurrencyConverter/CurrencyConverter';
import ClaimImagesSlider from './ClaimImagesSlider';
import validate from './validate';
import updateClaimForHostMutation from './updateClaimForHost.graphql';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { convert, showCurrencySymbol } from '../../helpers/currencyConvertion';
import { withMutation } from '../../hoc/withGraphql';
import cs from '../commonStyle.css';
import s from './HostClaimModal.css';
import messages from '../../locale/jsonMessages';

class HostClaimModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = { loading: false, claimImages: [], imageLoader: false, isUploadComplete: false };
        this.removeImage = this.removeImage.bind(this);
    }
    renderFormControl = ({ input, placeholder, type, meta: { touched, error }, className, maxLength, disabled }) => {
        const { formatMessage } = this.props.intl;
        const { claimed, currency, currencyRates, toCurrency, baseCurrency } = this.props;
        let addonCurreny = !toCurrency ? (showCurrencySymbol(baseCurrency) == "" ? baseCurrency : showCurrencySymbol(baseCurrency)) : showCurrencySymbol(toCurrency) == "" ? toCurrency : showCurrencySymbol(toCurrency);
        if (claimed || input.name == 'securityDeposit') {
            return (
                <div className={className}>
                    <CurrencyConverter amount={Number(input.value)} from={currencyRates.to} className={s.currencyConverterInput} />
                </div>
            )
        }
        return (
            <div className={cx('claimAddon')}>
                <InputGroup>
                    <InputGroup.Addon>
                        {addonCurreny}
                    </InputGroup.Addon>
                    <FormControl
                        {...input}
                        placeholder={placeholder}
                        type={type}
                        className={className}
                        disabled={disabled}
                        maxLength={maxLength}
                    />
                </InputGroup>

                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </div>
        )
    }
    renderFormControlTextArea = ({ input, placeholder, meta: { touched, error }, disabled, className }) => {
        const { formatMessage } = this.props.intl;
        const { claimed } = this.props;
        if (claimed) {
            return (
                <div className={cs.commonSmallText16}>
                    {input.value ? input.value : '-'}
                </div>
            )
        }
        return (
            <div>
                <FormControl
                    {...input}
                    className='commonTextAreaField'
                    componentClass="textarea"
                    placeholder={placeholder}
                    disabled={disabled}
                />
                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </div>
        );
    }
    async handleSubmit(values, dispatch) {
        const { updateClaimForHost, reservationId, refetchData, currencyRates, currency } = this.props;
        let claimAmount = convert(currencyRates.base, currencyRates.rates, values.claimAmount, currencyRates.to || currencyRates.base, currency);

        this.setState({ loading: true });
        const { data } = await updateClaimForHost({ variables: { reservationId, claimAmount, claimImages: values.claimImages, claimReason: values.claimReason } });

        if (data?.updateClaimForHost?.status == 200) {
            showToaster({ messageId: 'claimAmountUpdate', toasterType: 'success' })
            this.closeModal();
        } else {
            showToaster({ messageId: 'uploadDocumentError', toasterType: 'error' })
            this.setState({ loading: false });
        }

        refetchData && refetchData();
    }

    async removeImage(image) {
        const { change, claimImages } = this.props;
        let updatedClaimImages = [...claimImages];
        const resp = await fetch('/remove/claim/photos', {
            method: "POST", body: JSON.stringify({ filename: image }), credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
        });
        const data = await resp.json();
        if (data?.status == 200) {
            this.setImageLoader(true);
            showToaster({ messageId: 'imageRemoved', toasterType: 'success' })
            if (Array.isArray(claimImages)) {
                let index = claimImages.findIndex(item => item == image);
                if (index > -1) updatedClaimImages.splice(index, 1);
            }
            change('claimImages', updatedClaimImages);
            this.setImageLoader(false);
        }


    }
    setImageLoader = status => this.setState({ imageLoader: status });
    closeModal = () => {
        const { changeModalState } = this.props;
        changeModalState(false);
    }
    setUploadComplete = status => this.setState({ isUploadComplete: status });
    render() {
        const { show, handleSubmit, claimImages, claimed, isDisableColor } = this.props;
        const { formatMessage } = this.props.intl;
        const { loading, imageLoader, isUploadComplete } = this.state;

        return (
            <Modal show={show} onHide={this.closeModal} dialogClassName={cx(s.hostClaimDetailsModalContainer, 'commonModalContainer')} >
                <Modal.Header closeButton className='commonModalHeader'>
                    <Modal.Title className='commonModalTitle'>
                        {claimed ? formatMessage(messages.claimDetails) : formatMessage(messages.claimDamage)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsClass='commonModalBody'>
                    <form onSubmit={handleSubmit(this.handleSubmit)}>
                        <div className="oneColumnGrid">
                            <FormGroup className={cx(cs.noMargin, { [s.claimDetailsBorder]: claimed }, { [cs.paddingBottom3]: claimed })}>
                                <ControlLabel className='commonLabelText'>
                                    <FormattedMessage  {...messages.depositAmount} />
                                </ControlLabel>
                                <Field
                                    name="securityDeposit"
                                    type="text"
                                    component={this.renderFormControl}
                                    placeholder={formatMessage(messages.depositAmount)}
                                    disabled
                                    className={cx(!claimed && ['commonInputField', s.grayColor])}
                                />
                            </FormGroup>
                            <FormGroup className={cx(cs.noMargin, { [s.claimDetailsBorder]: claimed }, { [cs.paddingBottom3]: claimed })}>
                                <ControlLabel className='commonLabelText'>
                                    {claimed
                                        ? <FormattedMessage  {...messages.amountClaimedByOwner} />
                                        : <FormattedMessage  {...messages.claimAmount} />
                                    }
                                </ControlLabel>
                                <Field
                                    name="claimAmount"
                                    type="text"
                                    component={this.renderFormControl}
                                    placeholder={formatMessage(messages.enterClaimAmount)}
                                    disabled={claimed}
                                    className={cx(!claimed && 'commonInputField')}
                                    maxLength={30}
                                />
                            </FormGroup>
                            <FormGroup className={cx(cs.noMargin, { [s.claimDetailsBorder]: claimed }, { [cs.paddingBottom3]: claimed })}>
                                <ControlLabel className='commonLabelText'>
                                    <FormattedMessage  {...messages.reasonForClaim} />
                                </ControlLabel>
                                <Field
                                    name="claimReason"
                                    type="text"
                                    component={this.renderFormControlTextArea}
                                    placeholder={formatMessage(messages.enterClaimReason)}
                                    disabled={claimed}
                                />
                            </FormGroup>
                            <div>
                                {!claimed &&
                                    <FormGroup className={cx({ [cs.spaceBottom4]: !claimImages },
                                        { [s.marginBottomNone]: (claimImages && claimImages.length > 0) })}>
                                        <ControlLabel className='commonLabelText'>
                                            <FormattedMessage  {...messages.uploadClaimImage} />
                                        </ControlLabel>
                                        <div className={cx(cs.commonMediumText, s.claimNoteText, cs.spaceBottom3)}>{formatMessage(messages.uploadClaimImageInfo)}</div>
                                        <Field
                                            name="claimImages"
                                            component={Dropzone}
                                            errorMessageClass={s.errorMessage}
                                            setImageLoader={this.setImageLoader}
                                            setUploadComplete={this.setUploadComplete}
                                        />
                                    </FormGroup>}
                                {
                                    claimed && claimImages && claimImages.length > 0 &&
                                    <label className='commonLabelText'>
                                        {formatMessage(messages.uploadedImages)}
                                    </label>
                                }

                                <div>
                                    {imageLoader && <Loader type={"text"} />}
                                    {
                                        !imageLoader && claimImages && claimImages.length > 0 &&
                                        <ClaimImagesSlider
                                            data={claimImages}
                                            arrow
                                            claimed={claimed}
                                            removeImage={this.removeImage}
                                            isUploadComplete={isUploadComplete}
                                        />
                                    }
                                </div>
                            </div>
                        </div>

                        {!claimed &&
                            <div className={cx(cs.spaceTop4, 'doubleBtnFlexEnd')}>
                                <Button onClick={this.closeModal} className={cx(cs.btnPrimaryBorder)}>
                                    {formatMessage(messages.cancel)}
                                </Button>
                                <Loader
                                    type={"button"}
                                    buttonType={"submit"}
                                    label={formatMessage(messages.submit)}
                                    show={loading}
                                    disabled={loading}
                                    className={cx(cs.btnPrimary, 'loaderButtonFlex')}
                                />
                            </div>}
                    </form>
                </Modal.Body>
            </Modal>
        )
    }
}

HostClaimModal = reduxForm({
    form: 'HostClaimModalForm',
    validate
})(HostClaimModal);

const selector = formValueSelector('HostClaimModalForm');

const mapState = state => ({
    claimImages: selector(state, 'claimImages'),
    currencyRates: state.currency,
    toCurrency: state.currency.to,
    baseCurrency: state.currency.base

});

const mapDispatch = {};

export default injectIntl(
    withMutation(updateClaimForHostMutation, {
        name: 'updateClaimForHost'
    })(withStyles(cs, s)(connect(mapState, mapDispatch)(HostClaimModal))));
